import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { HttpService } from '../helper/httpService';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserEnvironmentService {
  private fpPromise = FingerprintJS.load();

  constructor(public http: HttpService) {}

  /**
   * Gather all environment details: device fingerprint, location, etc.
   */
  async getEnvironmentDetails(): Promise<any> {
    try {
      // Get device fingerprint
      const fp = await this.fpPromise;
      const fingerprintResult = await fp.get();
      const deviceFingerprint = fingerprintResult.visitorId;

      // Get IP and location details
      //const location = await this.getIpAndLocation();

      return {
        deviceFingerprint,
        ipAddress: "20.90.134.22",
        country: "GB",
        region: "England",
        city: "London",
      };
    } catch (error) {
      // console.error('Error gathering environment details:', error);
      throw error;
    }
  }

  /**
   * Fetch IP and location details from a third-party API
   */
  private async getIpAndLocation(): Promise<any> {
    const url = 'https://ipapi.co/json/';
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      // console.log('Fetch Response:', data);
      if (!data || !data.ip) {
        throw new Error('Invalid response from IPWhois service');
      }
      return data;
    } catch (error) {
      // console.error('Fetch failed:', error);
      throw error;
    }
  }
}
